// La `.progress-mini` del mockup: 60×5 px, inline, alineada al medio para no romper la línea base.
import { cn } from '@/lib/cn';

/** `null` deja la barra en cero y sin color de semáforo: no hay avance que juzgar. */
export function ProgressMini({ pct, className }: { pct: number | null; className?: string }) {
    const width = pct === null ? 0 : Math.min(Math.max(Math.round(pct * 100), 0), 100);
    const tone =
        pct === null
            ? 'bg-transparent'
            : width >= 80
              ? 'bg-success'
              : width >= 40
                ? 'bg-warning'
                : 'bg-danger';

    return (
        <span
            className={cn(
                'inline-block h-[5px] w-[60px] flex-none self-center overflow-hidden rounded-[3px] bg-muted',
                className,
            )}
        >
            <span
                className={cn('block h-full rounded-[3px]', tone)}
                style={{ width: `${String(width)}%` }}
            />
        </span>
    );
}
